var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 2.36039C11.6602 1.87987 12.3398 1.87987 12.5176 2.36039L13.9893 6.33766C15.7027 6.9396 17.0604 8.29725 17.6623 10.0107L21.6396 11.4824C22.1201 11.6602 22.1201 12.3398 21.6396 12.5176L17.6623 13.9893C17.0604 15.7028 15.7028 17.0604 13.9893 17.6623L12.5176 21.6396C12.3398 22.1201 11.6602 22.1201 11.4824 21.6396L10.0107 17.6623C8.29725 17.0604 6.9396 15.7027 6.33766 13.9893L2.36039 12.5176C1.87987 12.3398 1.87987 11.6602 2.36039 11.4824L6.33766 10.0107C6.9396 8.29725 8.29725 6.9396 10.0107 6.33766L11.4824 2.36039ZM12.8308 14.4342C13.3659 14.2517 13.8215 13.8977 14.1323 13.4377C14.4095 13.0273 14.5714 12.5326 14.5714 12C14.5714 10.5798 13.4202 9.42857 12 9.42857C11.7044 9.42857 11.4205 9.47844 11.1562 9.57022C10.6267 9.75407 10.176 10.1061 9.86775 10.5623C9.59049 10.9727 9.42859 11.4674 9.42859 12C9.42859 13.4201 10.5799 14.5714 12 14.5714C12.2907 14.5714 12.5702 14.5232 12.8308 14.4342Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9067 7.37772L18.4356 6.22763C18.6295 5.80592 18.1941 5.37056 17.7724 5.56447L16.6223 6.09329C17.1005 6.46802 17.532 6.89954 17.9067 7.37772Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37772 6.09324L6.22775 5.56447C5.80604 5.37056 5.37068 5.80592 5.56459 6.22763L6.09336 7.37758C6.46806 6.89944 6.89957 6.46794 7.37772 6.09324Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09335 16.6224L5.56459 17.7723C5.37068 18.194 5.80604 18.6294 6.22775 18.4355L7.37771 17.9067C6.89956 17.532 6.46806 17.1005 6.09335 16.6224Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6224 17.9067L17.7724 18.4355C18.1941 18.6294 18.6295 18.194 18.4356 17.7723L17.9068 16.6222C17.532 17.1004 17.1005 17.5319 16.6224 17.9067Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindRose);
export default __webpack_public_path__ + "static/media/wind-rose.a12e67ab8a835a6ccf6ef453a9417d83.svg";
export { ForwardRef as ReactComponent };